import React, { useState } from 'react'
import classNames from 'classnames'
import { TextViewModelFragment, GenericModalPageMetadataFragment } from '#src/generated/graphql'
import { Modal, ModalContent } from '@deal/components'
import AttributedHtmlText from '#src/components/AttributedHtmlText'
import styles from './styles.css'

interface Props {
  questionText?: TextViewModelFragment | null
  questionSubText?: TextViewModelFragment | null
  genericModalMetadata?: GenericModalPageMetadataFragment | null
  className?: string
}

const QuestionHeader: React.SFC<Props> = ({
  questionText,
  questionSubText,
  genericModalMetadata,
  className
}) => {
  const [isModalOpen, setModalOpen] = useState(false)

  if (questionText || questionSubText) {
    return (
      <div className={classNames(styles.question, className)}>
        {questionText && (
          <h3 className={styles.questionText}>
            <AttributedHtmlText text={questionText} testId="question-text" />
          </h3>
        )}

        {questionSubText && (
          <p className={styles.questionSubText}>
            <AttributedHtmlText text={questionSubText} testId="question-subtext" />

            {genericModalMetadata && genericModalMetadata.openCtaText && genericModalMetadata.body && (
              <p className={styles.modalTrigger}>
                <span className={styles.linkText} onClick={() => setModalOpen(true)}>
                  <AttributedHtmlText text={genericModalMetadata.openCtaText} />
                </span>
                <Modal isOpen={isModalOpen} onRequestClose={() => setModalOpen(false)}>
                  <ModalContent>
                    <AttributedHtmlText text={genericModalMetadata.body} />
                  </ModalContent>
                </Modal>
              </p>
            )}
          </p>
        )}
      </div>
    )
  }
  return null
}

export default QuestionHeader
